import { useUserStore } from '@st/user/stores/useUserStore'
import { provideVipClubDeps } from '@st/vip-club/useDeps'
import { useBonusesCountStore } from '@st/bonuses/stores/useBonusesCountStore'

export default defineNuxtPlugin({
  name: 'vipClubDeps',
  dependsOn: ['i18n:plugin', 'i18n-base-init', 'bonusesDeps'],
  setup: () => {
    const userStore = useUserStore()
    const { isAuthenticated, isReady } = storeToRefs(userStore)
    const { vipBonusesCount } = storeToRefs(useBonusesCountStore())

    provideVipClubDeps({
      isAuthenticated,
      vipBonusesCount,
      isReady,
    })
  },
})
